import { useEffect, useCallback } from 'react';
import { Drawer, Form, message } from 'antd';

import request from '@/request';

import InputItem from '../../components/InputItem';
import SelectorItem from '../../components/SelectorItem';
import SaveButton from '../../components/SaveButton';

export default function EditDrawer({ open, onClose, initialData, onSave }) {
  const [form] = Form.useForm();
  const nameVal = Form.useWatch('name', form);
  const idCardVal = Form.useWatch('idCard', form);
  const certificateVal = Form.useWatch('certificate', form);
  const phoneVal = Form.useWatch('phone', form);
  const cityVal = Form.useWatch('city', form);

  useEffect(() => {
    if (open && initialData) {
      // 编辑模式：设置表单初始值
      form.setFieldsValue({
        name: initialData.name,
        contact: initialData.phone,
      });
    } else if (!open) {
      // 关闭时重置表单
      form.resetFields();
    }
  }, [open, initialData, form]);

  const onConfirm = useCallback(async () => {
    try {
      const values = await form.validateFields();
      await request.post('/events/referee/one', {
        name: values.name,
        idCard: values.idCard,
        phone: values.phone,
        certificate: values.certificate,
        cityName: values.city.name,
        cityCode: values.city.areaCode,
      });
      message.success('创建成功');
      onSave?.();
    } catch (error) {
      console.error('请求失败:', error);
    } finally {
      onClose();
    }
  }, [form, onClose, onSave]);

  return (
    <Drawer
      title={`${initialData?.id ? '编辑' : '创建'}裁判信息`}
      size={400}
      onClose={onClose}
      open={open}
      extra={<SaveButton text="保存" onSave={onConfirm} />}
    >
      <Form form={form} layout="vertical">
        <div className="space-y-4">
          <Form.Item
            name="name"
            rules={[{ required: true, message: '请输入姓名' }]}
          >
            <InputItem
              label="姓名"
              placeholder="请输入姓名"
              value={nameVal}
              onChange={(v) => form.setFieldsValue({ name: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="idCard"
            rules={[{ required: true, message: '请输入身份证号' }]}
          >
            <InputItem
              label="身份证号"
              placeholder="请输入身份证号"
              value={idCardVal}
              onChange={(v) => form.setFieldsValue({ idCard: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="certificate"
            rules={[{ required: true, message: '请输入证件号' }]}
          >
            <InputItem
              label="证件号"
              placeholder="请输入证件号"
              value={certificateVal}
              onChange={(v) => form.setFieldsValue({ certificate: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="phone"
            rules={[{ required: true, message: '请输入联系电话' }]}
          >
            <InputItem
              label="联系电话"
              placeholder="请输入联系电话"
              value={phoneVal}
              onChange={(v) => form.setFieldsValue({ phone: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="city"
            rules={[{ required: true, message: '请选择所在城市' }]}
          >
            <SelectorItem
              label="比赛城市"
              type="address"
              require
              value={cityVal}
              onChange={(v) => form.setFieldsValue({ city: v })}
            />
          </Form.Item>
        </div>
      </Form>
    </Drawer>
  );
}
